import { constants } from '..';

const setDropdownsLoadingAction = flag => ({
  type: constants.dropdowns.SET_DROPDOWNS_LOADING,
  flag,
});

const getCountriesAction = () => ({
  type: constants.dropdowns.GET_COUNTRIES,
});

const setCountriesAction = countries => ({
  type: constants.dropdowns.SET_COUNTRIES,
  countries,
});

const getObjectNumbersAction = () => ({
  type: constants.dropdowns.GET_OBJECT_NUMBERS,
});

const setObjectNumbersAction = objectNumbers => ({
  type: constants.dropdowns.SET_OBJECT_NUMBERS,
  objectNumbers,
});

const setDropdownsErrorAction = error => ({
  type: constants.dropdowns.SET_DROPDOWNS_ERROR,
  error,
});

export const dropdownsActions = {
  setDropdownsLoadingAction,
  getCountriesAction,
  setCountriesAction,
  getObjectNumbersAction,
  setObjectNumbersAction,
  setDropdownsErrorAction,
};
